import { COUNTRIES_WITH_POPULAR } from '@/constants/countries';

import { Option } from '@/types/components/common';
import { CountryISO } from '@/types/places';

export function getForeignTaxResidencyCountryOptions(
  tenantCountryCode: string,
  translatedCountry: Record<string, string>,
): Option[] {
  return COUNTRIES_WITH_POPULAR.filter(
    ({ value }) =>
      String(value).toUpperCase() !== tenantCountryCode.toUpperCase() &&
      String(value).toUpperCase() !== CountryISO.US,
  ).map(item => ({
    ...item,
    text: translatedCountry[item.value] ?? item.text,
  }));
}
